export var InlineCssClass;
(function (InlineCssClass) {
    InlineCssClass["Base"] = "iress-inline";
    InlineCssClass["Inner"] = "iress-inline__inner";
    InlineCssClass["AlignLeft"] = "iress-inline--left";
    InlineCssClass["AlignCenter"] = "iress-inline--center";
    InlineCssClass["AlignRight"] = "iress-inline--right";
    InlineCssClass["InlineNone"] = "iress-inline--none";
    InlineCssClass["InlineXs"] = "iress-inline--xs";
    InlineCssClass["InlineSm"] = "iress-inline--sm";
    InlineCssClass["InlineMd"] = "iress-inline--md";
    InlineCssClass["InlineLg"] = "iress-inline--lg";
    InlineCssClass["InlineXl"] = "iress-inline--xl";
    InlineCssClass["InlineSmNone"] = "iress-inline-sm--none";
    InlineCssClass["InlineSmXs"] = "iress-inline-sm--xs";
    InlineCssClass["InlineSmSm"] = "iress-inline-sm--sm";
    InlineCssClass["InlineSmMd"] = "iress-inline-sm--md";
    InlineCssClass["InlineSmLg"] = "iress-inline-sm--lg";
    InlineCssClass["InlineSmXl"] = "iress-inline-sm--xl";
    InlineCssClass["InlineMdNone"] = "iress-inline-md--none";
    InlineCssClass["InlineMdXs"] = "iress-inline-md--xs";
    InlineCssClass["InlineMdSm"] = "iress-inline-md--sm";
    InlineCssClass["InlineMdMd"] = "iress-inline-md--md";
    InlineCssClass["InlineMdLg"] = "iress-inline-md--lg";
    InlineCssClass["InlineMdXl"] = "iress-inline-md--xl";
    InlineCssClass["InlineLgNone"] = "iress-inline-lg--none";
    InlineCssClass["InlineLgXs"] = "iress-inline-lg--xs";
    InlineCssClass["InlineLgSm"] = "iress-inline-lg--sm";
    InlineCssClass["InlineLgMd"] = "iress-inline-lg--md";
    InlineCssClass["InlineLgLg"] = "iress-inline-lg--lg";
    InlineCssClass["InlineLgXl"] = "iress-inline-lg--xl";
    InlineCssClass["InlineXlNone"] = "iress-inline-xl--none";
    InlineCssClass["InlineXlXs"] = "iress-inline-xl--xs";
    InlineCssClass["InlineXlSm"] = "iress-inline-xl--sm";
    InlineCssClass["InlineXlMd"] = "iress-inline-xl--md";
    InlineCssClass["InlineXlLg"] = "iress-inline-xl--lg";
    InlineCssClass["InlineXlXl"] = "iress-inline-xl--xl";
})(InlineCssClass || (InlineCssClass = {}));
export var InlineAlign;
(function (InlineAlign) {
    InlineAlign["Left"] = "left";
    InlineAlign["Center"] = "center";
    InlineAlign["Right"] = "right";
})(InlineAlign || (InlineAlign = {}));
export var InlineGutter;
(function (InlineGutter) {
    InlineGutter["None"] = "none";
    InlineGutter["Xs"] = "xs";
    InlineGutter["Sm"] = "sm";
    InlineGutter["Md"] = "md";
    InlineGutter["Lg"] = "lg";
    InlineGutter["Xl"] = "xl";
})(InlineGutter || (InlineGutter = {}));
//# sourceMappingURL=inline.types.js.map